import { Button, Checkbox, Container, Group, Image, Paper, PasswordInput, Text, TextInput } from "@mantine/core";
import { useContext, useState } from "react";
import { Link, useNavigate } from "react-router";
import logo from '../../../asset/logo.png';
import { Constant } from "../../../models/constant";
import { LoginResponse } from "../../../models/login";
import { AppCtx } from "../../../provider/AppContext";
import { getErrorMessage } from "../../../services/api-client";
import { apiService } from "../../../services/api.service";

function Login() {
    const [username, setUsername] = useState<string>();
    const [password, setPassword] = useState<string>();
    const [errorMsg, setErrorMsg] = useState<string>();
    const [loading, setLoading] = useState(false);
    const appContex = useContext(AppCtx);
    const navigate = useNavigate();

    const onLoginClick = async () => {
        setErrorMsg(undefined);
        setLoading(true);
        try {
            const response = await apiService.Login({
                username: username!,
                password: password!
            });
            login(response.data);
        } catch (error) {
            setErrorMsg(getErrorMessage(error, 'Accesso non riuscito.'));
        } finally {
            setLoading(false);
        }
    }

    const login = (loginResponse: LoginResponse) => {
        if (!loginResponse)
            return;

        localStorage.setItem(Constant.LS_ACCESS_TOKEN_KEY, loginResponse.access_token);
        localStorage.setItem(Constant.LS_USER_KEY, JSON.stringify(loginResponse.user));
        appContex.setIsLogged(true);
        navigate('/home');
    }

    return (
        <Container size={420} my={40}>
            <Group justify="center">
                <Image src={logo} fit="contain" h={100} w={'auto'} />
            </Group>

            <Paper withBorder shadow="md" p={30} mt={30} radius="md">
                <TextInput label="Username o mail" placeholder="Username o mail..." onChange={(e: any) => setUsername(e.target.value)} required />
                <PasswordInput label="Password" placeholder="Password..." onChange={(e: any) => setPassword(e.target.value)} onKeyDown={(event) => { if (event.key === 'Enter') onLoginClick() }} required mt="md" />
                <Group justify="space-between" mt="lg">
                    <Checkbox label="Ricordami" />
                </Group>
                {errorMsg && <Text c={'red'} w='100%' mt="xl" ta="center">{errorMsg}</Text>}
                <Button fullWidth mt="xl" onClick={onLoginClick} loading={loading} disabled={!username || !password}>
                    Accedi
                </Button>
                <Text w='100%' mt="xl" ta="center">Hai dimenticato la password? <Link to={'/auth/recupero-password'}>Clicca qui</Link></Text>
            </Paper>
        </Container>
    )
}

export default Login;
